import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d637ed64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "telehealth-page-wrapper" }
const _hoisted_2 = { class: "d-flex flex-row h-100 w-100" }
const _hoisted_3 = {
  key: 0,
  class: "menu-pane d-flex flex-col flex-no-wrap p-l-16 p-r-16 p-t-16"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-t-32" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Write To Encounter Note ")
const _hoisted_6 = {
  key: 1,
  class: "video-view"
}
const _hoisted_7 = {
  key: 0,
  class: "w-100 h-100 d-flex flex-col justify-content-center align-items-center"
}
const _hoisted_8 = { class: "w-512" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Join Call")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Call Again")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Call Patient")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!
  const _component_PatientInfoHeader = _resolveComponent("PatientInfoHeader")!
  const _component_AppointmentDetails = _resolveComponent("AppointmentDetails")!
  const _component_PatientDetails = _resolveComponent("PatientDetails")!
  const _component_ChatView = _resolveComponent("ChatView")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_VideoViewTopControls = _resolveComponent("VideoViewTopControls")!
  const _component_VideoView = _resolveComponent("VideoView")!
  const _component_ProviderChatView = _resolveComponent("ProviderChatView")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.appointmentDataLoaded)
      ? (_openBlock(), _createBlock(_component_PageWrapper, {
          key: 0,
          class: "telehealth-loader-wrapper",
          contentWidthMobile: "",
          contentBodyBottomMarginDisabled: "",
          contentNotchCorrectionDisabled: ""
        }, {
          "content-center": _withCtx(() => [
            _createVNode(_component_EventStateSpinner, {
              isLoading: true,
              loadingIcon: "icon-find-a-clinic",
              loadingTitle: "Loading Appointment Data...",
              failureIcon: "icon-clinic"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_page, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.appointmentDataLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_PatientInfoHeader, {
                  appointment: _ctx.appointmentData,
                  patient: _ctx.patientProfile,
                  "remote-patient": _ctx.patientRemoteProfile,
                  "remote-profile-id": _ctx.appointmentData.remotePatientId
                }, null, 8, ["appointment", "patient", "remote-patient", "remote-profile-id"]),
                _createVNode(_component_AppointmentDetails, {
                  class: "m-t-32",
                  appointment: _ctx.appointmentData,
                  "microphone-status": _ctx.remotePatientAudioStatus,
                  "video-status": _ctx.remotePatientVideoStatus
                }, null, 8, ["appointment", "microphone-status", "video-status"]),
                _hoisted_4,
                _createVNode(_component_PatientDetails, {
                  class: "m-t-24",
                  patient: _ctx.patientProfile,
                  remotePatient: _ctx.patientRemoteProfile
                }, null, 8, ["patient", "remotePatient"]),
                (!_ctx.appointmentData.isChat)
                  ? (_openBlock(), _createBlock(_component_ChatView, {
                      key: 0,
                      class: "m-t-32",
                      onSend: _ctx.sendTextMessage,
                      onSendFile: _ctx.sendDocumentMessage,
                      onInput: _ctx.singleTyping,
                      typing: _ctx.showTypingIndication,
                      "chat-items": _ctx.chatItems,
                      disabled: !_ctx.remoteConnected(),
                      "document-chat-disabled": !_ctx.isDocumentChatAvailable
                    }, null, 8, ["onSend", "onSendFile", "onInput", "typing", "chat-items", "disabled", "document-chat-disabled"]))
                  : _createCommentVNode("", true),
                (!_ctx.appointmentData.isChat && _ctx.doesEncounterNoteEndpointExist && _ctx.doesSaveDocumentToChartExist)
                  ? (_openBlock(), _createBlock(_component_BaseButton, {
                      key: 1,
                      class: "save-to-encounter-btn m-t-32",
                      color: _ctx.ButtonColor.PRIMARY,
                      pattern: _ctx.ButtonColorPattern.FILL,
                      disabled: !_ctx.hasChatMessages,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.writeChatToEncounterNote()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["color", "pattern", "disabled"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.appointmentDataLoaded && !_ctx.appointmentData.isChat)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_VideoView, {
                  onCall: _ctx.startCall,
                  onEnd: _ctx.endCall,
                  onFlip: _ctx.cycleCamera,
                  onToggleVideo: _ctx.toggleVideo,
                  onMute: _ctx.toggleMute,
                  onChat: _ctx.toggleChat,
                  onCycleView: _ctx.cycleVideoDisplayMode,
                  state: _ctx.videoControlState,
                  "allow-view-cycle": "",
                  "override-top-controls": ""
                }, {
                  "top-controls": _withCtx(() => [
                    _createVNode(_component_VideoViewTopControls, {
                      "call-time": _ctx.videoControlState.callTime,
                      onExit: _ctx.onExit
                    }, null, 8, ["call-time", "onExit"])
                  ]),
                  default: _withCtx(() => [
                    (_ctx.showCallPatientSpinner())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_EventStateSpinner, {
                              textColorLight: "",
                              isLoading: true,
                              loadingIcon: _ctx.loaderData.icon,
                              loadingTitle: _ctx.loaderData.title,
                              loadingMessage: _ctx.loaderData.message,
                              failureIcon: "icon-clinic"
                            }, null, 8, ["loadingIcon", "loadingTitle", "loadingMessage"]),
                            (_ctx.remotePatient && _ctx.remotePatient.isPublishing)
                              ? (_openBlock(), _createBlock(_component_BaseButton, {
                                  key: 0,
                                  onClick: _ctx.startCall,
                                  pattern: "fill"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_ctx.shouldShowCallAgain || _ctx.callOver)
                                ? (_openBlock(), _createBlock(_component_BaseButton, {
                                    key: 1,
                                    onClick: _ctx.startCall,
                                    pattern: "fill",
                                    disabled: _ctx.callButtonDisabled
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  }, 8, ["onClick", "disabled"]))
                                : (_openBlock(), _createBlock(_component_BaseButton, {
                                    key: 2,
                                    onClick: _ctx.startCall,
                                    pattern: "fill",
                                    disabled: _ctx.callButtonDisabled
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  }, 8, ["onClick", "disabled"]))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onCall", "onEnd", "onFlip", "onToggleVideo", "onMute", "onChat", "onCycleView", "state"])
              ]))
            : (_ctx.appointmentDataLoaded)
              ? (_openBlock(), _createBlock(_component_ProviderChatView, {
                  key: 2,
                  "chat-items": _ctx.chatItems,
                  "patient-profile": _ctx.patientProfile,
                  "show-typing-indication": _ctx.showTypingIndication,
                  "patient-connected": _ctx.patientConnected,
                  "show-write-to-encounter-button": _ctx.doesEncounterNoteEndpointExist,
                  onSaveToEncounterNote: _cache[1] || (_cache[1] = ($event: any) => (_ctx.writeChatToEncounterNote())),
                  onSendMessage: _ctx.sendTextMessage,
                  onSendFile: _ctx.sendDocumentMessage,
                  onSignalTyping: _ctx.singleTyping,
                  onExit: _ctx.onExit
                }, null, 8, ["chat-items", "patient-profile", "show-typing-indication", "patient-connected", "show-write-to-encounter-button", "onSendMessage", "onSendFile", "onSignalTyping", "onExit"]))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}